module.exports = __webpack_public_path__ + "static/media/fpslogo.81ef08d9.png";